import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../providers/api.service';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { MatDialog } from '@angular/material/dialog';
import { AddNewBookingComponent } from 'src/app/shared/components/add-new-booking/add-new-booking.component';
import { ManageBookingComponent } from 'src/app/shared/components/manage-booking/manage-booking.component';
import { AssignJobComponent } from 'src/app/shared/components/assign-job/assign-job.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { CustomiseBookingComponent } from 'src/app/shared/components/customise-booking/customise-booking.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { AddEditTaxGstComponent } from 'src/app/shared/components/add-edit-tax-gst/add-edit-tax-gst.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { InternationalTaxConfigurerComponent } from '../../new-v2-pages/new-v2-component/international-tax-configurer/international-tax-configurer.component';
import { AddEditDomesticTaxConfigComponent } from '../../new-v2-pages/new-v2-component/add-edit-domestic-tax-config/add-edit-domestic-tax-config.component';
import { AddEditInternationalTaxConfigComponent } from '../../new-v2-pages/new-v2-component/add-edit-international-tax-config/add-edit-international-tax-config.component';
import { BillInvoiceTypeComponent } from '../../new-v2-pages/new-v2-component/bill-invoice-type/bill-invoice-type.component';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';

@Component({
  selector: 'sm-taxandgst',
  templateUrl: './taxandgst.component.html',
  styleUrls: ['./taxandgst.component.scss']
})
export class TaxandgstComponent implements OnInit, OnDestroy {
  isEntityForeign: string = localStorage.getItem(SM_CONSTANTS.IS_ENTITY_FOREIGN)!
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  taxData: any = []
  taxSlabsData:any = []
  toShowCheck: number = 1
  private _apiSubscription: Subscription;
  loader: boolean = false
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, public _modelRef: MatDialog,  private loaderService: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{

      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_DATA){
        this.taxData = []
        if(resData.result){
          resData.result.forEach((element:any) => {
            this.taxData.push(element)
            this.toShowCheck = this.taxData[0].entity_tax_collection_status
          });
        }
        else{
          this.toShowCheck = 0
        }
     
        this._apiService.getEntityTaxSlabData(this.entityHashId)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA){
        this.taxSlabsData = []
        if(resData.result){
          this.taxSlabsData = resData.result
        }
        this.loaderService.showLoader = false
        this.loader = false
        if(this.isChangingStatus == true){
          const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
            width: '600px',
            data : {
              title : 'Alert',
              message : 'You have enabled tax in your business successfully. Now add the tax data with services and products.  Ignore this If you have already added taxes in them. ',
              okbtn : 'Ok',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });
          this.isChangingStatus = false
        }
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_DATA){
        this.taxData = []
        if(resData.result){
          this.taxData.push(resData.result)
          this.taxData[0].tax_types = typeof this.taxData[0].tax_types == 'string' ? JSON.parse(this.taxData[0].tax_types) : this.taxData[0].tax_types 
          this.taxData[0].tax_values = typeof this.taxData[0].tax_values == 'string' ? JSON.parse(this.taxData[0].tax_values) : this.taxData[0].tax_values 
          this.toShowCheck = this.taxData[0]?.tax_collection_status ?? 0
        }
        else{
          this.toShowCheck = 0
        }
        console.log(this.taxData);
        
        this._apiService.getInternationalEntityTaxSlabsData(this.entityHashId)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA){
        this.taxSlabsData = []
        if(resData.result){
          this.taxSlabsData = resData.result
          this.taxSlabsData.forEach((element:any) => {
            element.tax_values = typeof element.tax_values == 'string' ? JSON.parse(element.tax_values) : element.tax_values
          });
        }
        this.loaderService.showLoader = false
        this.loader = false
        if(this.isChangingStatus == true){
          const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
            width: '600px',
            data : {
              title : 'Alert',
              message : 'You have enabled tax in your business successfully. Now add the tax data with services and products.  Ignore this If you have already added taxes in them. ',
              okbtn : 'Ok',
              cancelbtn : 'Cancel',
              type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
            },
            disableClose : true
          });
          this.isChangingStatus = false
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_TAX_DATA){
        if(resData.result){
          this._apiService.getEntityTaxData(this.entityHashId)
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_ENTITY_PRIMARY_TAX_DATA){
        if(resData.result){
          this._apiService.getEntityTaxData(this.entityHashId)
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION){
        if(resData.result){
          this._apiService.getInternationalEntityTaxData(this.entityHashId)
        }
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_SLABS_DATA){
        if(resData.result){
          this._apiService.getInternationalEntityTaxData(this.entityHashId)
        }
      }

    });
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
   }

  ngOnInit(): void {

    // this.loader = true  
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    }) 
   
    if(this.isEntityForeign == '0'){
      this.loaderService.showLoader = true
      this.loader = true
      this._apiService.getEntityTaxData(this.entityHashId)

    }else if(this.isEntityForeign == '1'){
      this.loaderService.showLoader = true
      this.loader = true
      this._apiService.getInternationalEntityTaxData(this.entityHashId)

    }



  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
  isChangingStatus: boolean = false
  onToggleChange(event: any) {
    if(this.isEntityForeign == '0'){
      if(event.checked){
        this.isChangingStatus = true
        this.toShowCheck = 1
        let data = {
          "pan_number": this.taxData[0]?.pan_number ? this.taxData[0]?.pan_number : null,
          "tan_number": this.taxData[0]?.tan_number ? this.taxData[0]?.tan_number : null,
          "gst_number": this.taxData[0]?.gst_number ? this.taxData[0]?.gst_number : null,
          "entity_hash": this.entityHashId,
          "bill_invoice_type": this.taxData[0]?.bill_invoice_type ?? 1,
          "tax_collection_status": 1
        }
        Object.keys(data).forEach(key => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditEntityPrimaryTaxData(data)
      }
      else if (!event.checked){
        this.toShowCheck = 0
        let data = {
          "pan_number": this.taxData[0]?.pan_number ? this.taxData[0]?.pan_number : null,
          "tan_number": this.taxData[0]?.tan_number ? this.taxData[0]?.tan_number : null,
          "gst_number": this.taxData[0]?.gst_number ? this.taxData[0]?.gst_number : null,
          "entity_hash": this.entityHashId,
          "bill_invoice_type": this.taxData[0]?.bill_invoice_type,
          "tax_collection_status": 0
        }
        Object.keys(data).forEach(key => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditEntityPrimaryTaxData(data)
      }

    }
    else if(this.isEntityForeign == '1'){
      if(event.checked){
        this.isChangingStatus = true
        this.toShowCheck = 1
        let data = {
          "entity_hash": this.entityHashId,
          "tax_collection_status": 1,
          "tax_types": this.taxData[0].tax_types ?  this.taxData[0].tax_types.map((item:any) => {
            return {
              "tax_type": item.taxation_type, 
              "identification_no": item.identification_no
            }
          }) : [],
          "bill_invoice_type": this.taxData[0]?.bill_invoice_type ?? 1,
        }
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditInternationalEntityTaxConfiguration(data)
      }
      else if (!event.checked){
        this.toShowCheck = 0
        let data = {
          "entity_hash": this.entityHashId,
          "tax_collection_status": 0,
          "tax_types": this.taxData[0].tax_types ?  this.taxData[0].tax_types.map((item:any) => {
            return {
              "tax_type": item.taxation_type, 
              "identification_no": item.identification_no
            }
          }) : [],
          "bill_invoice_type": this.taxData[0]?.bill_invoice_type,
        }
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditInternationalEntityTaxConfiguration(data)
      }

    }
  }
  onToggleChangeOfSlab(event: any,item:any) {
    if(this.isEntityForeign == '0'){
      if(event.checked){
        item.tax_collection_status = 1
        let data = {
          "tax_name": item.tax_name,
          "tax_desc": item.tax_desc,
          "gstStatus": item.gst_status,
          "cgstStatus": item.cgst_status,
          "igstStatus": item.igst_status,
          "sgstStatus": item.sgst_status,
          "utgstStatus": item.utgst_status,
          "serviceTaxStatus": item.service_tax_status,
          "otherTaxStatus": item.other_tax_status,
          "sgstValue": item.sgst_value,
          "cgstValue": item.cgst_value,
          "igstValue": item.igst_value,
          "utgstValue": item.utgst_value,
          "otherTax": item.other_tax,
          "otherTaxName": item.other_tax_name,
          "serviceTaxValue": item.service_tax_value,
          "hash_id": item.hash_id,
          "editedBy": item.edited_by,
          "createdBy": item.created_by,
          "businessHashId": item.business_hash_id,
          "tax_collection_status": item.tax_collection_status
      }
      Object.keys(data).forEach(key => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditEntityTaxData(data)
      }
      else if (!event.checked){
        item.tax_collection_status = 0
        let data = {
          "tax_name": item.tax_name,
          "tax_desc": item.tax_desc,
          "gstStatus": item.gst_status,
          "cgstStatus": item.cgst_status,
          "igstStatus": item.igst_status,
          "sgstStatus": item.sgst_status,
          "utgstStatus": item.utgst_status,
          "serviceTaxStatus": item.service_tax_status,
          "otherTaxStatus": item.other_tax_status,
          "sgstValue": item.sgst_value,
          "cgstValue": item.cgst_value,
          "igstValue": item.igst_value,
          "utgstValue": item.utgst_value,
          "otherTax": item.other_tax,
          "otherTaxName": item.other_tax_name,
          "serviceTaxValue": item.service_tax_value,
          "hash_id": item.hash_id,
          "editedBy": item.edited_by,
          "createdBy": item.created_by,
          "businessHashId": item.business_hash_id,
          "tax_collection_status": item.tax_collection_status
      }
      Object.keys(data).forEach(key => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditEntityTaxData(data)
      }

    }
    else if(this.isEntityForeign == '1'){
      if(event.checked){
        item.tax_collection_status = 1
        let data = {
          "hash_id": item.hash_id,
          "tax_slab_name": item.slab_name,
          "tax_slab_desc": item.slab_desc,
          "entity_hash": item.entity_hash,
          "tax_collection_status": item.tax_collection_status,
          "tax_values": item.tax_values  ? item.tax_values.map((element:any) => {
            return {
              "tax_name": element.tax_name,
              "tax_value": element.tax_percentage
            }
          }) : []
        }
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditInternationalEntityTaxSlabsData(data)
      }
      else if (!event.checked){
        item.tax_collection_status = 0
        let data = {
          "hash_id": item.hash_id,
          "tax_slab_name": item.slab_name,
        "tax_slab_desc": item.slab_desc,
          "entity_hash": item.entity_hash,
          "tax_collection_status": item.tax_collection_status,
          "tax_values": item.tax_values ?  item.tax_values.map((element:any) => {
            return {
              "tax_name": element.tax_name,
              "tax_value": element.tax_percentage
            }
          }) : []
        }
        this.loaderService.showLoader = true
        // this.loader = true
        this._apiService.addEditInternationalEntityTaxSlabsData(data)
      }

    }
  }

  opennewconfigureTax(){
    sessionStorage.removeItem('ifc')
    this.router.navigate(['configure-tax-gst'],{relativeTo: this.route, queryParamsHandling: 'preserve'});
  }

  configureTax(){
    this._modelRef.open(AddEditTaxGstComponent, {
      width: '700px',
      data: {
        title: 'Tax Details',
        ref: this._modelRef,
        data: this.taxData[0]
      },
    });
  }


  newconfigureTax(){
    this._modelRef.open(InternationalTaxConfigurerComponent, {
      width: '700px',
      data: {
        title: 'Tax Details',
        ref: this._modelRef,
        data: this.taxData[0]
      },
    });
  }

  openDomesticTaxConfig(){
    let dialogref = this._modelRef.open(AddEditDomesticTaxConfigComponent,{
      width: '600px',
      data:{
        ref: this._modelRef,
        taxData: this.taxData[0],
        entityHash: this.entityHashId
      }
    })
    // dialogref.afterClosed().subscribe(res =>{
    //   if(res){
    //     this.loaderService.showLoader = true
    //     this._apiService.getEntityTaxData(this.entityHashId)
    //   }
    // })
  }


  openbillinvoicetype(type:any){
    let dialogref = this._modelRef.open(BillInvoiceTypeComponent,{
      width: '600px',
      data:{
        ref: this._modelRef,
        taxData: this.taxData[0],
        type: type,
        entityHash: this.entityHashId
      }
    })

    // dialogref.afterClosed().subscribe(res => {
    //   if(res){
    //     if(type == 0){
       
    //       this._apiService.getEntityTaxData(this.entityHashId)
    //     }
    //     else if(type == 1){
        
    //       this._apiService.getInternationalEntityTaxData(this.entityHashId)
    //     }
    //   }
    // })
  }

  openInternationalTaxConfig(){
    let dialogref = this._modelRef.open(AddEditInternationalTaxConfigComponent,{
      width: '600px',
      data:{
        ref: this._modelRef,
        taxData: this.taxData[0],
        entityHash: this.entityHashId
      }
    })
    // dialogref.afterClosed().subscribe(res =>{
    //   if(res){
    //     this.loaderService.showLoader = true
    //     this._apiService.getEntityTaxData(this.entityHashId)
    //   }
    // })
  }

  onRedirectToConfig(index:any){
    sessionStorage.setItem('ifc', index)
    this.router.navigate(['configure-tax-gst'],{relativeTo: this.route, queryParamsHandling: 'preserve'});
  }

}


